import { render, staticRenderFns } from "./Editlabel.vue?vue&type=template&id=2093e606&scoped=true"
import script from "./Editlabel.vue?vue&type=script&lang=js"
export * from "./Editlabel.vue?vue&type=script&lang=js"
import style0 from "./Editlabel.vue?vue&type=style&index=0&id=2093e606&prod&lang=scss&scoped=true"
import style1 from "./Editlabel.vue?vue&type=style&index=1&id=2093e606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093e606",
  null
  
)

export default component.exports